import { createFileRoute } from "@tanstack/react-router";
import { DatasourceBrowser } from "src/containers/DatasourceBrowser";
import { validateBrowserSearch } from "src/services/datasources/browserSearchSchema";

export const Route = createFileRoute("/_layout-nosidebar/assets")({
    component: Assets,
    validateSearch: validateBrowserSearch,
});

function Assets() {
    return <DatasourceBrowser kind="asset" />;
}
